<template>
  <div id="contact" class="contact">
    <headline>Contact</headline>
    ご連絡は「<a href="https://twitter.com/_habaki_" target="_blank" rel="noopener noreferrer">鈨組のTwitterDM</a
    >」にて受け付けております。
  </div>
</template>

<script>
import headline from './common/headline'
export default {
  name: 'Contact',
  components: { headline }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/variables';
.contact {
  text-align: center;
  a {
    color: $text-white;
    text-decoration: none;
  }
  margin-bottom: 100px;
}
</style>
